import ExaminationSidebar from "../../components/sidebar/ExaminationSidebar";
import ExaminationNavbar from "../../components/navbar/ExaminationNavbar.jsx";
import "./studentsOverview.scss";
import { useEffect, useState } from "react";
import LineCharts from "../../components/chart/LineChart";
import ExaminationCard from "../../components/card/ExaminationCard.jsx";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CustomPieChart from "../../components/chart/PieChart.jsx";
import Select from "react-select";
import { serverUrl } from "../../temp.js";
import Skeleton from "@mui/material/Skeleton";
import StackedBarChart from "../../components/chart/StackedBarChart.jsx";
import SubjectBarChart from "../../components/chart/SubjectBarChart.jsx";
import { StackedBarChartType } from "../../enum.js";
import { formatMonths } from "../../generalServices.js";
import MonthlyLineChart from "../../components/chart/MonthlyLineChart.jsx";

const samplePieData = [
  { name: "A1", value: 20 },
  { name: "A+", value: 36 },
  { name: "A", value: 42 },
  { name: "B", value: 38 },
  { name: "C", value: 25 },
  { name: "Retry", value: 25 },
];

const StudentsOverview = () => {
  const centerId = localStorage.getItem("center_id") || 38;
  const [token] = useState(true);
  const [file, setFile] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(
    localStorage.getItem("sidebar")
  );
  const [selectedClassId, setSelectedClassId] = useState(() => {
    const stored = localStorage.getItem("class-id");
    return stored ? stored : "7"; // Default to class ID 7 if nothing stored
  });
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [initialStudentSet, setInitialStudentSet] = useState(false);

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState(null);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  // Options states
  const [monthOptions, setMonthOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [teacherOptions, setTeacherOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);

  // Chart data states
  const [lineChartData, setLineChartData] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  const [stackedBarChartData, setStackedBarChartData] = useState([]);
  const [subjectKeys, setSubjectKeys] = useState([]);

  const idealGrades = ["A1", "A", "B", "C", "D", "Retry"];
  const idealColors = [
    "#00C49F",
    "#0088FE",
    "#FFBB28",
    "#FF8042",
    "#AF19FF",
    "#FF193D",
  ];

  const [cardData, setCardData] = useState({
    attendance_percentage: 0,
    overall_average: 0,
    subject_averages: 0,
  });

  const [subjectBarChartData, setSubjectBarChartData] = useState([]);

  // Loading states
  const [loadingSubjectBarChart, setLoadingSubjectBarChart] = useState(false);
  const [loading, setLoading] = useState({
    months: true,
    subjects: true,
    teachers: true,
    students: true,
    lineChart: true,
    pieChart: true,
    stackedBarChart: true,
    cards: true,
    studentMonthly: true,
    studentSubject: true,
  });

  const [studentMonthlyAverages, setStudentMonthlyAverages] = useState([]);
  const [studentSubjectMonthly, setStudentSubjectMonthly] = useState([]);
  const [selectedSubjectName, setSelectedSubjectName] = useState("");
  const [monthLabelMap, setMonthLabelMap] = useState({});

  const redirectToLogin = () => {
    alert("Please Login first then you can access this page...");
    window.location.href = "/";
  };

  // useEffect(() => {
  //     setFile("/images.png");
  // }, []);

  // Set default student when student options are loaded
  useEffect(() => {
    if (studentOptions.length > 0 && !selectedStudents) {
      setSelectedStudents(studentOptions[0]);
      setInitialStudentSet(true); // Mark initial student as set
    }
  }, [studentOptions]);

  useEffect(() => {
    const fetchStudentImage = async () => {
      setIsImageLoading(true);
      if (selectedStudents) {
        const studentId = selectedStudents.value;
        try {
          const response = await fetch(`${serverUrl}/student/${studentId}`);
          const data = await response.json();

          if (data.code === "200" && data.data.image_url) {
            setFile(data.data.image_url);
          } else {
            setFile("/noUser.png");
          }
        } catch (error) {
          console.error("Error fetching student image:", error);
          setFile("/noUser.png");
        }
      } else {
        setFile("/noUser.png");
      }
      setIsImageLoading(false);
    };
    if (!selectedClassId || !selectedStudents) return;
    fetchStudentImage();
  }, [selectedStudents]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    localStorage.setItem("sidebar", !sidebarOpen);
  };

  const handleClassChange = (newClassId) => {
    setSelectedClassId(newClassId);
    localStorage.setItem("class-id", newClassId);

    // Reset filters when class changes
    setSelectedMonths([]);
    setSelectedSubjects([]);
    setSelectedTeachers([]);
    setSelectedStudents(null);
  };

  // Fetch month options
  useEffect(() => {
    fetch(
      `${serverUrl}/result_dashboard/month_dropdown?centerId=${centerId}&classId=${selectedClassId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setMonthOptions(
            data.data.map((month) => ({
              value: month.month,
              label: month.month_name,
            }))
          );
        }
        setLoading((prev) => ({ ...prev, months: false }));
      })
      .catch((error) => {
        console.error("Error fetching months:", error);
        setLoading((prev) => ({ ...prev, months: false }));
      });
  }, [selectedClassId]);

  // Fetch subject options when class changes
  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, subjects: true }));
    fetch(
      `${serverUrl}/result_dashboard/subject_dropdown?centerId=${centerId}&classId=${selectedClassId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setSubjectOptions(
            data.data.map((subject) => ({
              value: subject.subject_id,
              label: subject.subject_name,
            }))
          );
        }
        setLoading((prev) => ({ ...prev, subjects: false }));
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
        setLoading((prev) => ({ ...prev, subjects: false }));
      });
  }, [selectedClassId]);

  // Fetch teacher options when subjects change
  useEffect(() => {
    if (!selectedClassId) {
      setTeacherOptions([]);
      setSelectedTeachers([]);
      return;
    }

    setLoading((prev) => ({ ...prev, teachers: true }));
    const subjectIds = selectedSubjects.map((sub) => sub.value);

    fetch(
      `${serverUrl}/result_dashboard/teacher_dropdown?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ subjectId: subjectIds }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setTeacherOptions(
            data.data.map((teacher) => ({
              value: teacher.id,
              label: teacher.teacher_name,
            }))
          );
        }
        setLoading((prev) => ({ ...prev, teachers: false }));
      })
      .catch((error) => {
        console.error("Error fetching teachers:", error);
        setLoading((prev) => ({ ...prev, teachers: false }));
      });
  }, [selectedClassId, selectedSubjects]);

  // Fetch student options when class changes
  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, students: true }));
    fetch(
      `${serverUrl}/result_dashboard/student_dropdown?centerId=${centerId}&classId=${selectedClassId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setStudentOptions(
            data.data.map((student) => ({
              value: student.id,
              label: student.name,
            }))
          );
        }
        setLoading((prev) => ({ ...prev, students: false }));
      })
      .catch((error) => {
        console.error("Error fetching students:", error);
        setLoading((prev) => ({ ...prev, students: false }));
      });
  }, [selectedClassId]);

  useEffect(() => {
    if (!selectedClassId || !selectedStudents) return;

    setLoading((prev) => ({ ...prev, cards: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const subjectIds = selectedSubjects.map((s) => s.value);

    fetch(
      `${serverUrl}/result_dashboard/student_card_data?centerId=${centerId}&classId=${selectedClassId}&studentId=${selectedStudents.value}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          months: monthIds,
          subjects: subjectIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setCardData(data.data);
        }
        setLoading((prev) => ({ ...prev, cards: false }));
      })
      .catch((error) => {
        console.error("Error fetching card data:", error);
        setLoading((prev) => ({ ...prev, cards: false }));
      });
  }, [selectedClassId, selectedMonths, selectedSubjects, selectedStudents]);

  // Fetch line chart data (class average)
  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, lineChart: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const subjectIds = selectedSubjects.map((s) => s.value);

    fetch(
      `${serverUrl}/result_dashboard/chart/class-average?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          monthids: monthIds,
          subjectids: subjectIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setLineChartData(data.data);
        }
        setLoading((prev) => ({ ...prev, lineChart: false }));
      })
      .catch((error) => {
        console.error("Error fetching line chart data:", error);
        setLoading((prev) => ({ ...prev, lineChart: false }));
      });
  }, [selectedClassId, selectedMonths, selectedSubjects]);

  // Fetch pie chart data
  useEffect(() => {
    if (!selectedClassId || !selectedStudents) return;

    setLoading((prev) => ({ ...prev, pieChart: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const studentIds = selectedStudents ? [selectedStudents.value] : [];

    console.log("studentIds", studentIds);
    console.log("selectedStudents", selectedStudents);

    fetch(
      `${serverUrl}/result_dashboard/pie-chart?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          monthids: monthIds,
          studentids: studentIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          const transformedData = idealGrades.map((grade) => ({
            name: grade,
            value: data.data[grade] ?? 0, // Use 0 if grade is missing
          }));

          console.log("transformedData", transformedData);
          setPieChartData(transformedData);
        }
        setLoading((prev) => ({ ...prev, pieChart: false }));
      })
      .catch((error) => {
        console.error("Error fetching pie chart data:", error);
        setLoading((prev) => ({ ...prev, pieChart: false }));
      });
  }, [selectedClassId, selectedMonths, selectedStudents]);

  // Fetch stacked bar chart data
  useEffect(() => {
    if (!selectedClassId || !selectedStudents) return;

    setLoading((prev) => ({ ...prev, stackedBarChart: true }));

    const monthIds = selectedMonths.map((m) => m.value);
    const studentIds = selectedStudents ? [selectedStudents.value] : [];
    // const subjectIds = selectedSubjects.map(s => s.value);

    fetch(
      `${serverUrl}/result_dashboard/overallresults?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          monthids: monthIds,
          studentids: studentIds,
          subjectids: [],
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          console.log("data.data overallresults", data.data);
          const { transformedData, subjects } = transformStackedBarData(
            data.data
          );
          console.log("transformedData", transformedData);

          // Sort by overall result in descending order
          const sortedData = [...transformedData].sort((a, b) => {
            return b.overall - a.overall;
          });

          console.log("sortedData", sortedData);

          setStackedBarChartData(sortedData);
          setSubjectKeys(subjects);
        }
        setLoading((prev) => ({ ...prev, stackedBarChart: false }));
      })
      .catch((error) => {
        console.error("Error fetching stacked bar chart data:", error);
        setLoading((prev) => ({ ...prev, stackedBarChart: false }));
      });
  }, [selectedClassId, selectedMonths, selectedStudents]);

  // Add new useEffect for subject-specific chart
  useEffect(() => {
    if (!selectedClassId || !selectedStudents) return;

    // Only fetch if exactly one subject is selected
    if (selectedSubjects.length !== 1) {
      setSubjectBarChartData([]);
      return;
    }

    setLoadingSubjectBarChart(true);

    const subjectId = selectedSubjects[0].value;
    const monthIds = selectedMonths.map((m) => m.value);
    const studentIds = selectedStudents ? [selectedStudents.value] : [];

    fetch(
      `${serverUrl}/result_dashboard/subjectresult?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          monthids: monthIds,
          studentids: studentIds,
          subjectids: [subjectId],
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          // Transform API data to chart format
          const transformedData = data.data.students.map((student) => {
            const subjectKey = Object.keys(student.subjects)[0];
            const subjectData = student.subjects[subjectKey];
            return {
              name: student.common_name,
              month: formatMonths(student.month),
              percentage: parseFloat(subjectData.percentage),
              // average: parseFloat(subjectData.percentage),
              grade: subjectData.grade,
            };
          });

          // Sort by percentage in descending order
          transformedData.sort((a, b) => b.percentage - a.percentage);
          setSubjectBarChartData(transformedData);
        }
        setLoadingSubjectBarChart(false);
      })
      .catch((error) => {
        console.error("Error fetching subject result data:", error);
        setLoadingSubjectBarChart(false);
      });
  }, [selectedClassId, selectedMonths, selectedStudents, selectedSubjects]);

  // Fetch student monthly averages
  useEffect(() => {
    if (!selectedClassId || !selectedStudents) return;

    setLoading((prev) => ({ ...prev, studentMonthly: true }));
    const monthIds = selectedMonths.map((m) => m.value);

    fetch(
      `${serverUrl}/result_dashboard/student_monthly_averages?centerId=${centerId}&classId=${selectedClassId}&studentId=${selectedStudents.value}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ months: monthIds }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          let transformed = Object.entries(data.data).map(
            ([month, average]) => ({
              name: formatMonths(month),
              Average: average,
            })
          );
          transformed.sort((a, b) => {
            // Convert "2025-06" -> [2025, 6]
            const [yearA, monthA] = a.name.split("-").map(Number);
            const [yearB, monthB] = b.name.split("-").map(Number);
            return yearA - yearB || monthA - monthB;
          });

          setStudentMonthlyAverages(transformed);
        }
        setLoading((prev) => ({ ...prev, studentMonthly: false }));
      })
      .catch((error) => {
        console.error("Error fetching student monthly averages:", error);
        setLoading((prev) => ({ ...prev, studentMonthly: false }));
      });
  }, [selectedClassId, selectedStudents, selectedMonths, monthLabelMap]);

  // Fetch student subject monthly percentages
  useEffect(() => {
    if (
      !selectedClassId ||
      !selectedStudents ||
      selectedSubjects.length !== 1
    ) {
      setStudentSubjectMonthly([]);
      setSelectedSubjectName("");
      return;
    }

    setLoading((prev) => ({ ...prev, studentSubject: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const subjectId = selectedSubjects[0].value;

    fetch(
      `${serverUrl}/result_dashboard/student_subject_monthly_percentages?centerId=${centerId}&classId=${selectedClassId}&studentId=${selectedStudents.value}&subjectId=${subjectId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ months: monthIds }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          let transformed = Object.entries(data.data.monthly_percentages).map(
            ([month, percentage]) => ({
              name: formatMonths(month),
              Average: percentage,
            })
          );
          transformed.sort((a, b) => {
            // Convert "2025-06" -> [2025, 6]
            const [yearA, monthA] = a.name.split("-").map(Number);
            const [yearB, monthB] = b.name.split("-").map(Number);
            return yearA - yearB || monthA - monthB;
          });

          setStudentSubjectMonthly(transformed);
          setSelectedSubjectName(data.data.subject_name);
        }
        setLoading((prev) => ({ ...prev, studentSubject: false }));
      })
      .catch((error) => {
        console.error(
          "Error fetching student subject monthly percentages:",
          error
        );
        setLoading((prev) => ({ ...prev, studentSubject: false }));
      });
  }, [
    selectedClassId,
    selectedStudents,
    selectedMonths,
    selectedSubjects,
    monthLabelMap,
  ]);

  // Helper function to transform API data for stacked bar chart
  const transformStackedBarData = (apiData) => {
    // Get unique subjects from all records
    const subjectSet = new Set();
    apiData.forEach((record) => {
      Object.keys(record).forEach((key) => {
        // Exclude non-subject fields
        if (
          !["month", "name", "common_name", "over all result"].includes(
            key.trim()
          )
        ) {
          subjectSet.add(key.trim());
        }
      });
    });

    const subjects = Array.from(subjectSet);

    // Group data by student common_name
    const groupedData = {};
    apiData.forEach((record) => {
      const studentName = record.common_name; // ✅ Using common_name now
      if (!groupedData[studentName]) {
        groupedData[studentName] = {
          scores: {},
          overall: 0,
        };
      }

      // Process subject scores
      subjects.forEach((subject) => {
        const subjectKey = subject.trim();
        if (record[subjectKey]) {
          if (!groupedData[studentName].scores[subjectKey]) {
            groupedData[studentName].scores[subjectKey] = [];
          }
          groupedData[studentName].scores[subjectKey].push(
            parseFloat(record[subjectKey])
          );
        }
      });

      // Store overall result from API
      if (record["over all result"]) {
        groupedData[studentName].overall = parseFloat(
          record["over all result"]
        );
      }
    });

    // Create transformed data array
    const transformedData = Object.keys(groupedData).map((studentName) => {
      const studentData = {
        name: studentName,
        overall: groupedData[studentName].overall,
      };
      subjects.forEach((subject) => {
        const subjectKey = subject.trim();
        if (groupedData[studentName].scores[subjectKey]) {
          // Calculate average score for the subject
          const sum = groupedData[studentName].scores[subjectKey].reduce(
            (a, b) => a + b,
            0
          );
          studentData[subjectKey] =
            sum / groupedData[studentName].scores[subjectKey].length;
        }
      });
      return studentData;
    });

    return { transformedData, subjects };
  };

  // Helper to format applied filters
  const formatAppliedFilters = (filters) => {
    return filters
      .filter((filter) => filter.value.length > 0)
      .map((filter) => ({
        label: filter.label,
        value: filter.value.map((v) => v.label).join(", "),
      }));
  };

  // Get applied filters for cards
  const cardFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Subject", value: selectedSubjects },
    { label: "Teacher", value: selectedTeachers },
    { label: "Student", value: selectedStudents ? [selectedStudents] : [] },
  ]);

  // Filters for charts
  const chartFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Subject", value: selectedSubjects },
  ]);

  // Filters for pie charts
  const pieFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Student", value: selectedStudents ? [selectedStudents] : [] },
  ]);

  const stackedBarFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Student", value: selectedStudents ? [selectedStudents] : [] },
    // { label: "Subject", value: selectedSubjects }
  ]);

  // Add applied filters for subject bar chart
  const subjectBarChartFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Student", value: selectedStudents ? [selectedStudents] : [] },
  ]);

  // Filters for student monthly charts
  const studentMonthlyFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Student", value: selectedStudents ? [selectedStudents] : [] },
  ]);

  const studentSubjectFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Student", value: selectedStudents ? [selectedStudents] : [] },
    { label: "Subject", value: selectedSubjects },
  ]);

  return (
    <>
      {!token && redirectToLogin()}
      {token && (
        <div className="studentOverview">
          {sidebarOpen ? (
            <ExaminationSidebar isOpen={sidebarOpen} toggle={toggleSidebar} />
          ) : undefined}
          <div className="homeContainer">
            <ExaminationNavbar
              isOpen={sidebarOpen}
              toggle={toggleSidebar}
              selectedClassId={selectedClassId}
              onClassChange={handleClassChange}
            />
            <div className="heading">
              <h2>Student Overview</h2>
            </div>

            <div className="widgets">
              <div className="left">
                {isImageLoading ? (
                  <div className="image-skeleton-container">
                    <Skeleton
                      variant="circular"
                      className="responsive-skeleton"
                      sx={{
                        width: "100%",
                        height: "100%",
                        bgcolor: "rgba(0, 0, 0, 0.08)",
                      }}
                    />
                  </div>
                ) : (
                  // <img src={file} alt="/images.png" />
                  <img
                    src={file}
                    alt="Profile"
                    onError={(e) => {
                      e.target.src = "/images.png";
                    }}
                  />
                )}
              </div>
              <div className="dropdown-container">
                <label htmlFor="dropdown1">Month</label>
                <Select
                  id="dropdown1"
                  isMulti
                  options={monthOptions}
                  value={selectedMonths}
                  onChange={setSelectedMonths}
                  isLoading={loading.months}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="dropdown-container">
                <label htmlFor="dropdown4">Student</label>
                <Select
                  id="dropdown4"
                  options={studentOptions}
                  value={selectedStudents}
                  onChange={setSelectedStudents}
                  isLoading={loading.students}
                  isClearable={false}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="dropdown-container">
                <label htmlFor="dropdown2">Subject</label>
                <Select
                  id="dropdown2"
                  isMulti
                  options={subjectOptions}
                  value={selectedSubjects}
                  onChange={setSelectedSubjects}
                  isLoading={loading.subjects}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
            </div>

            <div className="widgets">
              <ExaminationCard
                type={"Attendance"}
                value={`${cardData.attendance_percentage} %`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
              <ExaminationCard
                type={"Overall Average"}
                value={`${cardData.overall_average} %`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
              <ExaminationCard
                type={"Subject Average"}
                value={`${cardData.subject_averages} %`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
              {/* <ExaminationCard type={"Course Covered"} value={"6 %"} icon={<PersonOutlinedIcon />} /> */}
            </div>

            {/* <div className="widgets">
                            <LineCharts title="Overall Average" />
                            <CustomPieChart data={samplePieData} title="Overall Remarks" />
                            <LineCharts title="Subject Average" />
                        </div> */}

            <div className="widgets">
              <MonthlyLineChart
                title="Overall Average"
                data={studentMonthlyAverages}
                loading={loading.studentMonthly}
                appliedFilters={studentMonthlyFilters}
              />
              <CustomPieChart
                data={pieChartData}
                colors={idealColors}
                loading={loading.pieChart}
                appliedFilters={pieFilters}
                title="Overall Remarks"
              />
            </div>

            <div className="widgets">
              <StackedBarChart
                title={"Overall Result"}
                data={stackedBarChartData}
                subjectKeys={subjectKeys}
                loading={loading.stackedBarChart}
                appliedFilters={stackedBarFilters}
                chartType={StackedBarChartType.RESULTS}
              />
            </div>
            <div className="widgets">
              {selectedSubjects.length === 1 && (
                <MonthlyLineChart
                  title={`${selectedSubjectName} Average`}
                  data={studentSubjectMonthly}
                  loading={loading.studentSubject}
                  appliedFilters={studentSubjectFilters}
                />
              )}
              {selectedSubjects.length === 1 && (
                <SubjectBarChart
                  title={`${selectedSubjects[0].label} Performance`}
                  data={subjectBarChartData}
                  loading={loadingSubjectBarChart}
                  appliedFilters={subjectBarChartFilters}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentsOverview;
